import React from 'react';
import PropTypes from 'prop-types';
import carDefault from '../../../assets/images/jellyDefault.png';
import carHover from '../../../assets/images/jellyHover.png';
import Image from '../../1_Atoms/Image/Image';
import { languageController } from '../../../controllers/language/languageController';

export const Jelly = ({
  topLabel,
  carName,
  carModel,
  carPrice,
  carImg,
  carImgHover,
  isInactive,
  ...otherProps
}) => {

  return (
    <div
      className={`mz-jelly ${isInactive ? 'inactive' : ''}`}
      {...otherProps}
    >

      {topLabel && <span className="mz-jelly-top">{topLabel}</span>}

      <div className="mz-jelly-container">
        <Image
          className="mz-jelly-image"
          src={carDefault}
          alt={carName}
          isLazy={false}
        />
        <Image
          className="mz-jelly-image--hover"
          src={carHover}
          alt={carName}
          isLazy={false}
        />
      </div>

      <div className="mz-jelly-content">
        <h5>{carName}</h5>
        <div className="mz-jelly-content__short-disc">{carModel}{carPrice ? ` - ${languageController.getCopy('global', 'from')} $${carPrice}` : ''}</div>
      </div>

      {isInactive && <p className="m-0 font-small upper ls-normal text--grey text--center strong">{languageController.getCopy('global', 'unavailableInRegion')}</p>}

    </div>
  );
};

Jelly.propTypes = {
  topLabel: PropTypes.string,
  carName: PropTypes.string,
  carModel: PropTypes.string,
  carPrice: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  carImg: PropTypes.string,
  carImgHover: PropTypes.string,
  isInactive: PropTypes.bool,
}

Jelly.defaultProps = {
  topLabel: '',
  carName: '',
  carModel: '',
  carPrice: '',
  carImg: '',
  carImgHover: '',
  isInactive: false
}

export default Jelly;